import React from 'react'
import { RenderDialogProps } from '../../../../legacy-design-system/action/confirmation-action'
import { ServerBulkActionWithFiltersProps } from '../row-action-list'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'
import { ConfirmDeleteServerDialog } from './delete-servers-confirm-dialog'

const mutationName = 'deleteServersByFilters'

export const deleteServersByFilters = gql`
  mutation DeleteServersWithFilters(
    $organizationID: ID!
    $deleteVulnerabilities: Boolean!
    $filters: ServerFilterArg!
  ) {
    ${mutationName}(
      input: {
        organizationID: $organizationID
        deleteVulnerabilities: $deleteVulnerabilities
        filters: $filters
      }
    ) {
      _placeholder
    }
  }
`

interface MutationData {
  readonly __typename: 'Mutation'
  readonly [mutationName]: {
    readonly _placeholder: boolean
    readonly __typename: 'ServerBulkResponse'
  }
}

interface MutationVariables {
  readonly filters: any
  readonly organizationID: string
  readonly deleteVulnerabilities: boolean
}

export function DeleteBulkWithFiltersDialog({
  filters,
  servers,
  isOpen,
  closeDialog,
  organizationID,
  refetchQueries,
  refresh
}: RenderDialogProps & ServerBulkActionWithFiltersProps) {
  return (
    <Mutation<MutationData, MutationVariables>
      mutation={deleteServersByFilters}
    >
      {(deleteServers) => {
        return (
          <ConfirmDeleteServerDialog
            organizationID={organizationID}
            servers={servers}
            isOpen={isOpen}
            closeDialog={closeDialog}
            deleteOperation={(deleteVulnerabilities) => {
              return deleteServers({
                refetchQueries,
                variables: {
                  filters,
                  organizationID,
                  deleteVulnerabilities
                },
                optimisticResponse: {
                  [mutationName]: {
                    _placeholder: true,
                    __typename: 'ServerBulkResponse'
                  },
                  __typename: 'Mutation'
                }
              })
                .then(refresh)
                .catch((error) => {
                  console.error(error)
                  return error
                })
            }}
          />
        )
      }}
    </Mutation>
  )
}
